import React from "react";
import { SovosPill } from "mosaic-react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const isVerifiedValue = (verified) => {
    const normalized = `${verified}`.toLowerCase();
    return normalized === "true" || normalized === "1";
};

const AccountVerified = (props) => {
    const { i18n } = useGlobalValue();
    const { value: cell } = props || {};
    const isVerified = isVerifiedValue(cell?.verified);
    const labelKey = isVerified ? "account-verified-true" : "account-verified-false";

    return (
        <SovosPill color={isVerified ? "success" : "neutral"}>{i18n`${labelKey}`}</SovosPill>
    );
};

export default AccountVerified;
